/*
 * Pro 2.0 "8 Reasons" landing page interactions. Delegated at document level (the section emits
 * a `.pro2-lp` wrapper), guarded against double-init. Add-to-cart is a direct /cart/add.js call
 * (not the Dawn <product-main> contract) — same pattern as probiotic-landing.js/kids-landing.js.
 */
(function () {
  'use strict';
  if (window.__pro2LPInit) return;
  window.__pro2LPInit = true;

  function init() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-pro2-thumb]');
      if (thumb) {
        var scope = thumb.closest('.pro2-lp') || document;
        var img = scope.querySelector('[data-pro2-gallery-img]');
        if (img) img.src = thumb.getAttribute('data-pro2-thumb');
        scope.querySelectorAll('[data-pro2-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        return;
      }

      var swatch = e.target.closest('[data-pro2-swatch]');
      if (swatch) {
        var sscope = swatch.closest('.pro2-lp') || document;
        var nameEl = sscope.querySelector('[data-pro2-color-name]');
        if (nameEl) nameEl.textContent = swatch.getAttribute('data-pro2-color-name') || '';
        sscope.querySelectorAll('[data-pro2-swatch]').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        var img2 = sscope.querySelector('[data-pro2-gallery-img]');
        var swatchImg = swatch.getAttribute('data-pro2-swatch');
        if (img2 && swatchImg) img2.src = swatchImg;

        var variantId = swatch.getAttribute('data-pro2-variant-id');
        var atcBtn = sscope.querySelector('[data-pro2-atc]');
        if (variantId && atcBtn) atcBtn.setAttribute('data-variant-id', variantId);
        return;
      }

      var card = e.target.closest('[data-pro2-flip]');
      if (card) { card.classList.toggle('flipped'); return; }
    });

    /* ---- "Ships today" countdown to end of day ---- */
    var countdown = document.querySelector('[data-pro2-countdown]');
    if (countdown) {
      var tick = function () {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 0);
        var diff = end - now;
        if (diff <= 0) { countdown.textContent = '0hr 0min'; return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        countdown.textContent = h + 'hr ' + m + 'min ' + s + 'sec';
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- Sticky CTA bar (hidden while the offer section is in view) ---- */
    var bar = document.querySelector('.pro2-lp .sticky-cta');
    var offer = document.getElementById('pro2-offer');
    if (bar) {
      var onScroll = function () {
        var show = window.scrollY > 700;
        if (offer) {
          var r = offer.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        }
        bar.classList.toggle('visible', show);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    initAddToCart();
  }

  /*
   * Real add-to-cart: hero variant + its (optional) selling plan, plus the two gift-with-purchase
   * lines, always included, in one /cart/add.js call. Gift lines carry the same _bundle_item /
   * _bundle_id properties the rest of the theme uses (subscription-selector.js, cart-drawer.liquid,
   * cart-gift-reconciler.js) so they lock/sync correctly once they land in the shared cart drawer.
   */
  function initAddToCart() {
    var mainBtn = document.querySelector('[data-pro2-atc]');
    if (!mainBtn) return; // no product selected — Liquid rendered a plain link instead
    var box = mainBtn.closest('[data-pro2-buybox]') || document;

    var addUrl =
      (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_add_url) || '/cart/add.js';

    function doAdd(sourceBtn) {
      if (sourceBtn.classList.contains('is-loading')) return;

      var variantId = mainBtn.getAttribute('data-variant-id');
      var productId = mainBtn.getAttribute('data-product-id');
      if (!variantId) return;

      var hasGifts = mainBtn.hasAttribute('data-gift-variant-id') || mainBtn.hasAttribute('data-gift2-variant-id');

      var mainItem = { id: variantId, quantity: 1 };
      var planId = mainBtn.getAttribute('data-selling-plan');
      if (planId) mainItem.selling_plan = planId;
      var subCopy = mainBtn.getAttribute('data-sub-property');
      mainItem.properties = {};
      if (subCopy) mainItem.properties.Subscription = subCopy;
      if (hasGifts && productId) {
        mainItem.properties._bundle_item = 'main';
        mainItem.properties._bundle_id = productId;
      }

      var items = [mainItem];

      ['data-gift-variant-id', 'data-gift2-variant-id'].forEach(function (attr) {
        var giftId = mainBtn.getAttribute(attr);
        if (!giftId) return;
        items.push({
          id: giftId,
          quantity: 1,
          properties: { _bundle_item: 'individual', _bundle_id: productId },
        });
      });

      setLoading(sourceBtn, true);
      clearError(box);

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          if (!r.ok) {
            throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart.');
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          setLoading(sourceBtn, false);
        })
        .catch(function (err) {
          setLoading(sourceBtn, false);
          showError(box, err && err.message ? err.message : 'Could not add to cart. Please try again.');
        });
    }

    mainBtn.addEventListener('click', function (e) {
      e.preventDefault();
      doAdd(mainBtn);
    });

    var stickyBtn = document.querySelector('[data-pro2-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        doAdd(stickyBtn);
      });
    }
  }

  function setLoading(btn, loading) {
    btn.classList.toggle('is-loading', loading);
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      btn.textContent = 'Adding…';
    } else {
      btn.removeAttribute('aria-busy');
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
    }
  }

  function clearError(box) {
    var el = box.querySelector('[data-pro2-atc-error]');
    if (el) {
      el.hidden = true;
      el.textContent = '';
    }
  }
  function showError(box, msg) {
    var el = box.querySelector('[data-pro2-atc-error]');
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    } else {
      window.alert(msg);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
